import { faPlus } from '@fortawesome/pro-light-svg-icons'
import TwinIcon from '../TwinIcon'
import RangeTableHeader from './RangeTableHeader'
import RangeTableRow from './RangeTableRow'
import { useCallback } from 'react'
import TwinTrans from '../TwinTrans'

export interface RangeTableData {
    id: number
    name: string
    values?: string[] | number[]
    active?: boolean
}
export type RangeTableDataDict = {[id: number]: RangeTableData}
interface RangeTableProps extends RangeTableLogicProps {
    tags: { header: string, rows: string }
    EditComponent?: React.ElementType
    editComponentProps?: any
}

const RangeTable: React.FC<RangeTableProps> = ({ ranges, tags, onChangeRanges, onChangeRangeRow, rangeData, EditComponent, editComponentProps }) => {
    const { addNewRange, deleteRange } = useRangeTableLogic({ ranges, onChangeRanges, rangeData, onChangeRangeRow })
    const renderRanges: JSX.Element[] = []
    for (const x in ranges) {
        const key = ranges[x]
        renderRanges.push(<RangeTableHeader key={'range-' + key} ranges={ranges} pos={parseInt(x)} tag={tags.header} {...{ onChangeRanges, deleteRange }} />)
    }
    const renderRangeRows: JSX.Element[] = []
    for (const k in rangeData) {
        const rowId = parseInt(k)
        const row = rangeData[rowId]
        renderRangeRows.push(<RangeTableRow key={'rangeRow-' + row.id} rangesLength={ranges?.length || 0} tag={tags.rows}{...{ onChangeRangeRow, rangeData, rowId, ranges, EditComponent, editComponentProps }} />)
    }
    return (
        <div className='overflow-auto flex flex-auto gap-x-5 h-1 w-full pr-15 '>
            <div>
                <div className=' h-50 flex items-center gap-x-5 sticky top-0 z-2 bg-white'>
                    <div className='medium14  h-full flex items-center bg-gray-F7 p-12 w-310'>
                        <TwinTrans transKey='appliedWhenLessThan'>Será aplicado cuando sea menor a</TwinTrans>
                    </div>
                    {renderRanges}
                </div>
                {renderRangeRows}
            </div>
            <div className='bg-gray-F7 flex  justify-center flex-col min-w-130 cursor-pointer h-full sticky top-0' onClick={addNewRange}>
                <TwinIcon icon={faPlus} size='1x' />
                <span className='medium16 text-center'>
                    <TwinTrans transKey='add'>Añadir</TwinTrans>
                </span>
            </div>
        </div>
    )
}

interface RangeTableLogicProps {
    ranges: number[]
    rangeData: RangeTableDataDict
    onChangeRangeRow: (rangeData: RangeTableDataDict) => void
    onChangeRanges: (ranges: number[]) => void
}

const useRangeTableLogic = ({ ranges, onChangeRanges, onChangeRangeRow, rangeData}: RangeTableLogicProps) => {
    const deleteRange = useCallback((pos: number) => {
        const rangesCopy = JSON.parse(JSON.stringify(ranges))
        const dataCopy = JSON.parse(JSON.stringify(rangeData))
        if (rangesCopy) {
            rangesCopy.splice(pos, 1)
        }
        for (const key in dataCopy) {
            dataCopy[key]?.values?.splice(pos, 1)
        }
        onChangeRangeRow(dataCopy)
        onChangeRanges(rangesCopy)
    }, [onChangeRanges, ranges, rangeData, onChangeRangeRow])

    const addNewRange = useCallback(() => {
        const rangesCopy = JSON.parse(JSON.stringify(ranges || []))
        const value = rangesCopy[rangesCopy?.length - 1] ?? -1
        rangesCopy.push(parseFloat(value) + 1)
        onChangeRanges(rangesCopy)
    }, [onChangeRanges, ranges])

    return { addNewRange, deleteRange }

}


export default RangeTable